import { render } from "./ModalDelete.vue?vue&type=template&id=b075a914"
import script from "./ModalDelete.vue?vue&type=script&lang=js"
export * from "./ModalDelete.vue?vue&type=script&lang=js"
script.render = render

export default script